import { Component, OnInit } from '@angular/core';
import { PopupService } from '../../../services/popup.service';
import { UserService } from '../../../services/user.service';
import { MyStuffService } from '../../../services/my-stuff.service';

import { Subscription } from 'rxjs';
import { PropertyService } from '../../../services/property.service';
import { BaseService } from '../../../services/base.service';
import { PinService } from '../../../services/pin.service';
import { RetailerService } from '../../../services/retailer.service';
import { RemovedItemsService } from '../../../services/removed-items.service';

@Component({
  selector: 'app-my-stuff',
  templateUrl: './my-stuff.component.html',
  styleUrls: ['./my-stuff.component.less']
})
export class MyStuffComponent implements OnInit {

  constructor(public popupService: PopupService, public myStuffService: MyStuffService,
              public userService: UserService, public propertyService: PropertyService,
              public baseService : BaseService, public pinService : PinService,
              public retailerService : RetailerService, public removedItemsService : RemovedItemsService) { }

  ngOnInit() {
  }

  closePopup() {
    this.popupService.updateRoute();
  }
}



// WEBPACK FOOTER //
// ./src/app/components/popups/my-stuff/my-stuff.component.ts